import { render } from "./LongTextType.vue?vue&type=template&id=5bf0fde7"
import script from "./LongTextType.vue?vue&type=script&lang=js"
export * from "./LongTextType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__